import {IPostList} from '../post/getPostList'
import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export type AnnounceType = 'all' | 'announcement' | 'media' | 'event' | 'others' | string
export type AnnounceTagsType = 'new' | 'important' | string

export interface IAnnouncement extends IPostList {
    categories?: AnnounceType[]
    tags?: AnnounceTagsType[]
    thumbnail?: string
    important_at?: number
    // pin_priority pins to the top independently of important_at: higher = higher,
    // 0 = unpinned. Kept separate so a non-important post can still be pinned.
    pin_priority?: number
    upload_at?: number
    created_at?: number
    notify?: boolean
    notify_expires_at?: number
}

export interface IAnnouncementList {
    id: string
    user_id: string
    title: string
    content: string
    thumbnail: string
    channel: string
    created_at: number
    updated_at: number
    upload_at: string
    important_at: number
    pin_priority: number
    categories: string[]
    visibility: number
    tags: any
}

export const getAnnounceList = async (
    current_page?: number,
    page_size?: number,
): Promise<ApiRes<IAnnouncementList[]>> => {
    return await apiGet(
        API_URL,
        `official/posts?current_page=${current_page}&page_size=${page_size}&sort=desc&sort_key=created_at`,
    )
}
